export default () => {
  // Apply to inputs, selects, and textareas
  const elements = document.querySelectorAll('input, select, textarea');

  elements.forEach(el => {
    // Handle different types of inputs
    const eventType = el.tagName.toLowerCase() === 'select' ? 'change' : 'input';

    el.addEventListener(eventType, () => {
      el.classList.add("text-black");
      el.classList.remove("text-gray-500");
    });
  });
}